<template>
  <nav class="layout-footer footer stream_footer bg-footer-theme sm_back_btn">
    <div class="container-fluid d-flex flex-wrap justify-content-between">

      <div class="back_btn">
        <b-link :to="{ name: 'dashboard'}" class="footer-link">
          <span class="ic-arrow-left2"></span>
          <span class="btn_txt">back</span>
        </b-link>
      </div>

      <div class="footer_links_with_back_btn">
        <b-link :to="{ name: 'streamDegree', params: {uuid: uuid} }" class="footer-link" :class="{'w-100': !isCareerEnabled}">Degree Progress</b-link>
        <b-link v-if="isCareerEnabled" :to="{ name: 'streamCareer', params: {uuid: uuid} }" class="footer-link">Career</b-link>
      </div>

    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'streamFooterNavbar',
  props: ['uuid', 'isCareerEnabled'],

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj
    })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/misc/components/StreamFooterNavbar.vue